export const ANALYTICS = {
  ROOT: '/analytics',
  CONTRACTOR: '/analytics/contractor',
  TRANSFER_TO_SETTLEMENT: '/analytics/transfer_to_settlement',
  RATING: '/analytics/rating',
  REPORTING_OVP: '/analytics/reporting_ovp',
  APARTMENT_STATUS: '/analytics/apartment_status',
};
